import { ResourceType } from "@core/shared/types";
import { trans } from "@mongez/localization";

export function useResourceLabel() {
  const getResourceTypeLabel = (type: ResourceType) => {
    switch (type) {
      case ResourceType.Pdf:
        return trans("pdfFile");
      case ResourceType.Docx:
        return trans("wordFile");
      case ResourceType.Xlsx:
        return trans("excelFile");
      case ResourceType.Pptx:
        return trans("powerpointFile");
      case ResourceType.Image:
        return trans("image");
      case ResourceType.Video:
        return trans("video");
      case ResourceType.Audio:
        return trans("audio");
      case ResourceType.Youtube:
        return trans("video");
      case ResourceType.Url:
        return trans("url");
      case ResourceType.Assessment:
        return trans("assessment");
      default:
        return trans("file");
    }
  };

  return {
    getResourceTypeLabel,
  };
}
